import { render, staticRenderFns } from "./SVC20000.vue?vue&type=template&id=5fa760c5&"
import script from "./SVC20000.vue?vue&type=script&lang=js&"
export * from "./SVC20000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports